const dialog = {
  "demo.trial.dialog.title": "You've unlocked the BYB trial",
  "demo.trial.dialog.description":
    "The trial is your starting line. Get the VR app and take the first step toward thinking faster, seeing sharper, and playing smarter.",
  "demo.trial.dialog.vr.cta": "Get the VR app",
  "demo.trial.dialog.converting.description": "Configuring your trial access",
  "demo.creating.account.dialog.title": "Setting up your account",
  "demo.creating.account.dialog.description": "We're creating your account and preparing your trial experience. This will only take a moment.",
};

const signIn = {
  "demo.signin.convert.title": "Sign in and start your 2-day trial",
  "demo.signin.convert.button": "Start trial",
};

export const demo = {
  ...dialog,
  ...signIn,
};

